module.exports = __webpack_public_path__ + "static/media/LOGOTUNZ.bd132647.png";